import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminMe, getToken, clearToken } from "@/lib/adminApi";
import { Loader2 } from "lucide-react";

export default function RequireAuth({ children }) {
  const [status, setStatus] = useState("checking"); // checking | ok | no

  useEffect(() => {
    if (!getToken()) { setStatus("no"); return; }
    adminMe().then(() => setStatus("ok")).catch(() => { clearToken(); setStatus("no"); });
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen grid place-items-center bg-cream">
        <Loader2 className="animate-spin text-plum" size={32} />
      </div>
    );
  }
  if (status === "no") return <Navigate to="/admin/login" replace />;
  return children;
}
